module.exports = __webpack_public_path__ + "img/tu16.ede88de2.png";